import { IResponsePaging } from "../models/base";
import { IDelivery } from "../models/deliveryModel";
import { user } from "../repositories/";

export default {
  addDelivery: async (
    query: any,
    callback: (data: IDelivery, err: any) => void
  ) => {
    try {
      const rs = await user.addDelivery(query);
      callback(rs.data, null);
    } catch (error) {
      let result: IDelivery = {};

      callback(result, error);
    }
  },
  getDeliveries: async (
    callback: (data: IResponsePaging<IDelivery[]> | null, err: any) => void
  ) => {
    try {
      const rs = await user.getDeliveries();
      callback(rs.data, null);
    } catch (error) {
      callback(null, error);
    }
  },
  getDelivery: async (
    id: string,
    callback: (data: IDelivery | null, err: any) => void
  ) => {
    try {
      const rs = await user.getDelivery(id);
      callback(rs.data, null);
    } catch (error) {
      callback(null, error);
    }
  },
  updateAvatar: async (query: any, callback: (data: any, err: any) => void) => {
    try {
      const rs = await user.updateAvatar(query);
      callback(rs.data, null);
    } catch (error) {
      callback(null, error);
    }
  },
  editDelivery: async (query: any, callback: (data: any, err: any) => void) => {
    try {
      const rs = await user.editDelivery(query);
      callback(rs.data, null);
    } catch (error) {
      callback(null, error);
    }
  },
};
